<template>
    <div>
        <hxlHeader />
        <div class="personalCenter">
            <hxlMenu class="menu" />
            <hxlContent class="right" />
        </div>
        <hxlFooder />
    </div>
</template>

<script>
import hxlHeader from "@/views/common/header.vue";
import hxlFooder from "@/views/common/fooder.vue";
import hxlMenu from './menu.vue';
import hxlContent from './content.vue';

export default {
    components: {
        hxlMenu, hxlContent,
        hxlHeader, hxlFooder,
    },
};
</script>

<style lang="scss">
.personalCenter {
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: flex-start;
    // height: 70vh;
    > div {
        &.menu {
            // max-height: 1000px;
            overflow-x: hidden;
            // width: 200px;
            // overflow-y: scroll;
            // height: 84vh;
            &::-webkit-scrollbar {
                width: 0;
            }
        }

        &.right {
            flex: 1;
            width: 900px;
            border: 1px solid #d3c290;
            margin-left: 20px;
            padding: 20px;
            // overflow-y: scroll;
            overflow-x: hidden;
            > div {
                // position: sticky;
                // top: 20px;
            }
        }
    }
}
</style>